import React, { useState, useEffect } from 'react';


// import './home.css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropertyCard from './propertyCard';


import {connect} from 'react-redux';
import * as actions from '../../store/property/actions';





const RelatedProperties = ({propertyTypeId, propertyType, entityId, getRelatedProperties, relatedProperties}) => {   

    
    useEffect(() => {
		loadData();
	},[]);

    const loadData = async() => {
        await getRelatedProperties({property_type_id: propertyTypeId, propertyType: propertyType, entity_id: entityId}).then(res => {
            // console.log()
        })
        
    }

    
    
    if(relatedProperties && relatedProperties.properties){
    return (
        <Col xs={12} className='mt-5'>
            <h4 className='mb-3'>Related Ads</h4>
            <Row>
                {
                    relatedProperties.properties.map((property, propertyIndex) => {
                        return <Col xs={4} key={`relatedProperty${propertyIndex}${property.etity_id}`}>
                                    <PropertyCard item={property} /> 
                                </Col>
                    }) 
                }
            </Row>
        </Col>
    )
    } else{
        return null;
    }
}
function mapStateToProps(state) {
    return {
        relatedProperties: state.property.relatedProperties
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        getRelatedProperties: (post) => dispatch(actions.getRelatedProperties(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(RelatedProperties);